import { render, staticRenderFns } from "./ColumnEditClickActionOptions.vue?vue&type=template&id=4212b2ea&scoped=true"
import script from "./ColumnEditClickActionOptions.vue?vue&type=script&lang=ts"
export * from "./ColumnEditClickActionOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212b2ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4212b2ea')) {
      api.createRecord('4212b2ea', component.options)
    } else {
      api.reload('4212b2ea', component.options)
    }
    module.hot.accept("./ColumnEditClickActionOptions.vue?vue&type=template&id=4212b2ea&scoped=true", function () {
      api.rerender('4212b2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ColumnEditClickActionOptions.vue"
export default component.exports